import * as React from "react";
import { cn } from "@/lib/utils";

interface DateInputProps extends Omit<React.ComponentProps<"input">, "type"> {
  id?: string;
  "aria-describedby"?: string;
  "aria-label"?: string;
}

const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  ({ className, id, "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, ...props }, ref) => {
    return (
      <input
        type="date"
        id={id}
        aria-describedby={ariaDescribedBy}
        aria-label={ariaLabel}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
DateInput.displayName = "DateInput";

export { DateInput };